import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
    const [checked, setChecked] = useState(false);

    const loadMe = useCallback(async () => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            setUser(false);
            setChecked(true);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            localStorage.removeItem(TOKEN_KEY);
            setUser(false);
        } finally {
            setChecked(true);
        }
    }, []);

    useEffect(() => { loadMe(); }, [loadMe]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem(TOKEN_KEY, data.token);
            setUser(data.user);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || "Login failed" };
        }
    };

    const logout = () => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, checked, login, logout, reload: loadMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
